import { useTheme } from '@qse/ui'
import { Outlet } from 'react-router-dom'

const AuthLayout = () => {
  const { theme } = useTheme()

  return (
    <div className=" grid lg:grid-cols-2 grid-cols-1 lg:overflow-hidden">
      <div className="lg:block h-screen hidden col-span-1 dark:bg-[#1E1E1E] bg-[#F9FAFD]  relative">
        <div className="flex justify-center items-center h-full   w-full">
          {theme === 'light' ? (
            <img alt="logo" className="w-full" src={'/assets/svg/logo-admin-light.svg'} />
          ) : (
            <img alt="logo" className="w-full" src={'/assets/svg/bg-logo-auth.svg'} />
          )}
        </div>
      </div>
      <div className="col-span-1 lg:h-screen h-full lg:overflow-y-scroll scrollbar-hide bg-white dark:bg-black text-gray-900 dark:text-white">
        <Outlet />
      </div>
    </div>
  )
}

export default AuthLayout
